import { render } from "./login.page.vue?vue&type=template&id=159715db&ts=true"
import script from "./login.page.vue?vue&type=script&lang=ts"
export * from "./login.page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__